"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sortItemsByTitle = sortItemsByTitle;
exports.sortItemsByType = sortItemsByType;
exports.sortItemsByTypeAndTitle = sortItemsByTypeAndTitle;
exports.sortItemsByFieldInOrder = sortItemsByFieldInOrder;
exports.filterTopicsByQuery = filterTopicsByQuery;
exports.filterTopicsByField = filterTopicsByField;
exports.filterTopicsByTopPicks = filterTopicsByTopPicks;
exports.getTopicsInFolder = getTopicsInFolder;
exports.getPreviousTopicInFolder = getPreviousTopicInFolder;
exports.getNextTopicInFolder = getNextTopicInFolder;
exports.getBrandYearModelTypeSubtypeKey = getBrandYearModelTypeSubtypeKey;
exports.getPrimaryPublication = getPrimaryPublication;
exports.filterByTypeSubType = filterByTypeSubType;

var _immutable = require("immutable");

var _contents = require("./contents");

/**
 * Sorts topics ONLY by title
 *
 * @param {Immutable.List} list
 * @param {boolean} descend
 * @returns {Immutable.List}
 */
function sortItemsByTitle(list) {
  var descend = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return list.sort(function (a, b) {
    var titleA = a.get('title').toLowerCase();
    var titleB = b.get('title').toLowerCase();
    if (titleA < titleB ^ descend) return -1;
    if (titleA > titleB ^ descend) return 1;
    return 0;
  });
}
/**
 * Sorts items ONLY by type (topic/folder)
 *
 * @param {Immutable.List} list
 * @param {boolean} descend
 * @returns {Immutable.List}
 */


function sortItemsByType(list) {
  var descend = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return list.sort(function (a, b) {
    if ((a.get('type') === "folder" && b.get('type') === "topic") ^ descend) return -1;
    if ((a.get('type') === "topic" && b.get('type') === "folder") ^ descend) return 1;
    return 0;
  });
}
/**
 * Sorts items by type (topic/folder) AND title
 *
 * @param {Immutable.List} list
 * @param {boolean} descend
 * @returns {Immutable.List}
 */


function sortItemsByTypeAndTitle(list) {
  var descend = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return list.sort(function (a, b) {
    if (a.get('type') === b.get('type')) {
      if (a.get('title') < b.get('title') ^ descend) return -1;
      if (a.get('title') > b.get('title') ^ descend) return 1;
    } else {
      if (a.get('type') === "folder" && b.get('type') === "topic") return -1;
      if (a.get('type') === "topic" && b.get('type') === "folder") return 1;
    }

    return 0;
  });
}
/**
 * Sorts items by type (topic/folder) and titles
 *
 * @param {Immutable.List|Array} list
 * @param {String} sortField
 * @param {Array} order
 * @returns {Immutable.List|Array}
 */


function sortItemsByFieldInOrder(list) {
  var sortField = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'id';
  var order = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

  // Return early in case of empty list
  if (!list) {
    return null;
  } //TODO: replace with Immutable.isImmutable() when 4.0.0 releases


  return list.get ? list.sort(function (a, b) {
    return order.indexOf(a.get(sortField)) - order.indexOf(b.get(sortField));
  }) : list.sort(function (a, b) {
    return order.indexOf(a[sortField]) - order.indexOf(b[sortField]);
  });
}
/**
 * Filters topics by search query
 *
 * @param {Immutable.List} list
 * @param {String} query
 * @returns {Immutable.List}
 */


function filterTopicsByQuery(list) {
  var query = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  if (!query) return list;
  return list.filter(function (topic) {
    return topic.get('title').toLowerCase().search(query.toLowerCase()) >= 0;
  });
}
/**
 * Filters topics by field
 *
 * @param {Immutable.List} topics
 * @param {Array} targetValues
 * @param {string} filterField - filter criteria
 * @param {boolean} preserveOrderAsTargetValues - preserve topics order in resulting list as per targetValues
 * @returns {Immutable.List}
 */


function filterTopicsByField(topics) {
  var targetValues = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var filterField = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'id';
  var preserveOrderAsTargetValues = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  if (!targetValues || targetValues.length === 0) return (0, _immutable.List)();

  if (!preserveOrderAsTargetValues) {
    return topics.filter(function (topic) {
      return targetValues.includes(topic.get(filterField));
    });
  }

  return targetValues.reduce(function (orderedList, targetValue) {
    return orderedList.push(topics.find(function (topic) {
      return topic.get(filterField) === targetValue;
    }));
  }, (0, _immutable.List)([])) // filtering empty topics (draft content)
  .filter(function (topic) {
    return topic;
  });
}
/**
 * Filter topics by top picks boolean flag
 *
 * @param {Immutable.List} list
 * @returns {Immutable.List}
 */


function filterTopicsByTopPicks(list) {
  return list.filter(function (topic) {
    return topic.get('promoted'); // boolean flag
  });
}
/**
 * @param {Immutable.Map} folder Folder to get topics from
 * @param {Boolean=} includeCollapsed Should we include folders with bodyHtml provided (used only for FR projects)
 * @returns {Immutable.List}
 */


function getTopicsInFolder(folder) {
  var includeCollapsed = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return folder.get('contents').valueSeq().filter(function (content) {
    return content.get('type') === 'topic' || includeCollapsed && content.get('bodyHtml');
  }).toList();
}
/**
 * @param {Immutable.List} topics
 * @param {Immutable.List} topicsInFolder
 * @param {Number} currentTopicIndex
 * @returns {Immutable.Map|null}
 */


function getPreviousTopicInFolder(topics, topicsInFolder, currentTopicIndex) {
  var previousTopicData = topicsInFolder.get(currentTopicIndex - 1);

  if (!previousTopicData) {
    return null;
  }

  return topics.find(function (topic) {
    return topic.get('resourceKey') === previousTopicData.get('resourceKey');
  });
}
/**
 * @param {Immutable.List} topics
 * @param {Immutable.List} topicsInFolder
 * @param {Number} currentTopicIndex
 * @returns {Immutable.Map|null}
 */


function getNextTopicInFolder(topics, topicsInFolder, currentTopicIndex) {
  var nextTopicData = topicsInFolder.get(currentTopicIndex + 1);

  if (!nextTopicData) {
    return null;
  }

  return topics.find(function (topic) {
    return topic.get('resourceKey') === nextTopicData.get('resourceKey');
  });
}
/**
 * Composes key from given params in format brand-year-model-productType-productSubtype
 *
 * @param {String} brand
 * @param {String} year
 * @param {String} model
 * @param {String} [productType]
 * @param {String} [productSubtype]
 * @returns {string}
 */


function getBrandYearModelTypeSubtypeKey(brand, year, model, productType, productSubtype) {
  var key = "".concat(brand, "-").concat(year, "-").concat(model);

  if (productType) {
    key = "".concat(key, "-").concat(productType);
  }

  if (productSubtype) {
    key = "".concat(key, "-").concat(productSubtype);
  }

  return key;
}
/**
 * Gets primary publication, contents tree is built upon it
 * Primary is considered to be the one with type 'OG' and contents
 * @param {Array} publications
 * @returns {Object}
 */


function getPrimaryPublication(publications) {
  return publications.find(function (p) {
    return p.publicationType === 'OG' && p.contents && p.contents.length;
  });
}
/**
 * Filter out redundant data in case there are vehicles with the same name and having product type and subtype provided
 *
 * NOTE: This filtering modifies the data object in place by dropping the unneeded sub-objects.
 *       Deep cloning in this case looks like a waste of memory assuming the data object can be huge.
 *       As we do this modification only once, when data is loaded, there should not be issues due to mutation.
 *
 * @param {Object} data
 * @param {String} productType
 * @param {String} productSubtype
 * @return {Object}
 */


function filterByTypeSubType(data, productType, productSubtype) {
  var filteredPublications = data.publications.filter(function (pub) {
    return pub.vehicles.find(function (v) {
      return (productType && v.FOREST_RIVER_PRODUCT_TYPE ? v.FOREST_RIVER_PRODUCT_TYPE === productType : true) && (productSubtype && v.FOREST_RIVER_PRODUCT_SUB_TYPE ? v.FOREST_RIVER_PRODUCT_SUB_TYPE === productSubtype : true);
    });
  }); // return early if there is no need to filter folders and topics

  if (data.publications.length === filteredPublications.length) {
    return data;
  }

  data.publications = filteredPublications; // primary publication is available in DITA XML

  var OGpublication = getPrimaryPublication(filteredPublications);

  if (OGpublication) {
    var filteredData = (0, _contents.filterTopicsAndFolders)(data, OGpublication);
    data.folders = filteredData.folders;
    data.topics = filteredData.topics;
  }

  return data;
}